<template>
  <div class="case container_box">
    <div class="case_header">
      <div class="case_header_title">
        <ul>
          <li>
            <p class="img"><img src="@/assets/pc/case/icon1.png" alt="" srcset=""></p>
            <p class="text">省市人社/省市工会</p>
            <p class="num">30+</p>
            <!-- <p class="text">省级工会合作</p> -->
          </li>
          <li>
            <p class="img"><img src="@/assets/pc/case/icon2.png" alt="" srcset=""></p>
            <p class="text">企业人力资源/集团工会</p>
            <p class="num">20000+</p>
            <!-- <p class="text">企业</p> -->
          </li>
          <li>
            <p class="img"><img src="@/assets/pc/case/icon3.png" alt="" srcset=""></p>
            <p class="text">培训机构/职业院校</p>
            <p class="num">5000+</p>
            <!-- <p class="text">人次</p> -->
          </li>
        </ul>
      </div>
    </div>

    <div class="case_info">
      <div class="case_tabs">
        <div
          class="case_tabs_list"
          v-for="(item, index) in tabList"
          :key="index"
          :class="index == currentIndex ? 'currentTabs' : ''"
          @click="changeIndex(index)"
        >
          <h3>{{ item.title }}</h3>
          <div></div>
        </div>
      </div>

      <div class="tab_pane">
        <div class="tab_pane_box" v-for="(item, index) in allList[currentIndex]['list']" :key="index+currentIndex">
          <div class="tab_pane_box_img">
            <img
              :src="require(`@/assets/pc/case/${item.urlName}${index + 1}.png`)"
              alt="图片"
            />
          </div>
          <div class="tab_pane_box_content">
            <p class="overflow_e">{{item.title}}</p>
            <!-- <el-link
              class="tab_pane_box_content_link"
              type="primary"
              :underline="false"
            >
              <span>了解更多</span>
              <i class="el-icon-arrow-right"></i>
            </el-link> -->
          </div>
        </div>
      </div>
      <pagination
      v-if="courseTotal > 0"
      :num="courseTotal"
      :limit="limit"
      @getNew="getNew"
    ></pagination>
    </div>
  </div>
</template>

<script>
import pagination from '@/components/pc/pagination.vue'
export default {
  components:{
    pagination
  },
  data() {
    return {
      currentIndex: 0,
       parmasData: {
        page: 1,
        per_page: 12,
      },
      num: 10, //数据总个数
      limit: 10, //一页显示几个
      nowPage: 1, //当前页码
      courseTotal: 10, //课程总数
      tabList: [
        { title: "职业技能培训" },
        { title: "智慧工会建设" },
        { title: "媒体运营服务" },
      ],
      allList: [
        {
          list: [
            { title: "技能强国", urlName: 'zyjn' },
            { title: "上合组织国家工匠研修学堂", urlName: 'zyjn' },
            { title: "中国金融工会线上学习平台", urlName: 'zyjn' },
            { title: "安徽工会五一学堂", urlName: 'zyjn' },
            { title: "湖北职工免费课堂", urlName: 'zyjn' },
            { title: "内蒙古技能强区", urlName: 'zyjn' },
            { title: "四川省职工职业培训平台", urlName: 'zyjn' },
          ],
        },
        {
          list: [
            { title: "中国职工经济技术信息化服务平台", urlName: 'zhgh' },
            { title: "广东省总工会劳模管理平台", urlName: 'zhgh' },
            { title: "内蒙古自治区创新成果申报管理平台", urlName: 'zhgh' },
            { title: "中国建筑业劳模工匠创新联盟", urlName: 'zhgh' },
            { title: "黑龙江省VR创新工作平台", urlName: 'zhgh' },
            { title: "湖北创新工作申报管理平台", urlName: 'zhgh' },
            { title: "2021内蒙古安康杯线上知识竞赛", urlName: 'zhgh' },
            { title: "全总劳模疗休养", urlName: 'zhgh' },
            { title: "首届大国工匠创新交流大会", urlName: 'zhgh' },
            { title: "2021内蒙古安康杯线上知识竞赛", urlName: 'zhgh' },
          ],
        },
        {
          list: [
            { title: "2021年技能强国技术春晚", urlName: 'mtyy' },
            { title: "2021年第七届全国职工职业技能大赛闭幕式宣传片", urlName: 'mtyy' },
            { title: "2021年全国总工会好网民主题活动宣传片", urlName: 'mtyy' },
            { title: "2022年全国总工会好网民主题活动宣传片", urlName: 'mtyy' },
            { title: "黑龙江省VR创新工作平台", urlName: 'mtyy' },
            { title: "湖北创新工作申报管理平台", urlName: 'mtyy' },
            { title: "百名劳模图片展", urlName: 'mtyy' },
            { title: "广东省“十四五”主题劳动和技能竞赛启动仪式宣传片", urlName: 'mtyy' },
            { title: "黑龙江省总工会五小创新五年成绩总结宣传片", urlName: 'mtyy' },
            { title: "中国航天科工二院参与上合组织国家工匠研修学堂汇报片", urlName: 'mtyy' },
            { title: "中国农业银行第六届业务技术比赛宣传片", urlName: 'mtyy' },
            { title: "中国农业银行劳模青年代表座谈会宣传片", urlName: 'mtyy' },
          ],
        },
      ]

    };
  },

  methods: {
    changeIndex(index) {
      console.log(index, 1111);
      console.log(this.allList[index]['list']);
      this.currentIndex = index;
    },
     getNew(nowPage) {
      this.nowPage = nowPage;
      this.parmasData.page = nowPage;
      this.getList();
    },
  }
};
</script>

<style lang="scss" scoped>
.case {
  background: #f7fbfc;
  margin-top: -84px;
  .case_header {
    width: 100%;
    background: url("@/assets/pc/case/case.png") 0 0 no-repeat;
    background-size: cover;
    text-align: center;
    height: 737px;
    .case_header_title {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      ul{
        margin-top: 271px;
        display: flex;
        li{
          // margin-right: 94px;
          margin-right: 43px;
          p.text{
            font-size: 18px;
            color: #FFFFFF;
          }
          p.num{
            font-size: 36px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #03E5C4;
            margin: 10px 0;
          }
        }
      }
    }
  }

  .case_info {
    width: 1200px;
    margin: 0 auto;
    margin-top: 114px;
    .case_tabs {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 24px;
      .case_tabs_list {
        h3 {
          font-size: 24px;
          color: #333333;
          margin-bottom: 21px;
          cursor: pointer;
        }
        div {
          // display: none;
          width: 74px;
          height: 0;
          opacity: 1;
          border-bottom: 3px solid #f7fbfc;
          border-radius: 5px;
          margin: auto;
        }
      }
      .currentTabs {
        h3 {
          color: #316cff;
        }
        div {
          // display: block;
          border-bottom: 3px solid #316cff;
        }
      }
    }

    .tab_pane {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      text-align: left;
      margin-top: 55px;
      .tab_pane_box {
        box-shadow: 0px 15px 20px 1px rgba(62, 105, 116, 0.1);
        margin-bottom: 25px;
        width: 384px;
        .tab_pane_box_img {
          width: 384px;
          height: 224px;
          img {
            width: 100%;
            height: 224px;
          }
        }
        .tab_pane_box_content {
          padding: 30px 13px 30px 20px;
          background: #fff;
          // min-height: 146px;
          position: relative;
          text-align: center;
          p {
            font-size: 22px;
            color: #333333;
            // line-height: 20px;
          }
          .tab_pane_box_content_link {
            font-size: 14px;
            color: #4b7fff;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            text-align: right;
            // margin-top: 53px;
            position: absolute;
            right: 20px;
            bottom: 20px;
            z-index: 1;
          }
        }
      }
    }
  }
}
</style>